import apiReminderMonitor from "../../api";

const extract = (res) => (res.status === "fulfilled" ? res.value?.data?.data ?? [] : []);

// Dropdown data of the Deliveries filter.
export const loadDeliveryFilterDependencies = async () => {
  const [rulesRes] = await Promise.allSettled([apiReminderMonitor.getRuleOptions()]);
  return { rules: extract(rulesRes) };
};
